export default __webpack_public_path__ + "static/media/bookPurple.bd866dd2.svg";